import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { DEFAULT_PAGE_SIZE } from '@/components/BaseTable/BaseTable';
import { LayoutDefault } from '@/components/LayoutDefault';
import { LayoutHeader } from '@/components/LayoutHeader';
import { LayoutHeaderTitle } from '@/components/LayoutHeaderTitle';
import { OrgDocsTable } from '@/components/OrgDocsTable/OrgDocsTable';
import { searchParam } from '@/utils/router';

export const orgDocsSearchSchema = z.object({
  pageSize: fallback(z.number(), DEFAULT_PAGE_SIZE).default(DEFAULT_PAGE_SIZE),
  pageIndex: fallback(z.number(), 0).default(0),
  search: searchParam().optional(),
  tag_ids: fallback(z.array(z.string()), []).optional(),
  sorting: fallback(
    z.array(
      z.object({
        id: z.string(),
        desc: z.boolean(),
      })
    ),
    [{ id: 'updated_at', desc: true }]
  ).default([{ id: 'updated_at', desc: true }]),
});

export type OrgDocsSearch = z.infer<typeof orgDocsSearchSchema>;

export const Route = createFileRoute('/$organizationName/org-docs/')({
  component: OrgDocsPage,
  validateSearch: zodValidator(orgDocsSearchSchema),
});

function OrgDocsPage() {
  return (
    <LayoutDefault
      navbarTitle="Org Docs"
      header={
        <LayoutHeader>
          <LayoutHeaderTitle title="Org Docs" />
        </LayoutHeader>
      }
    >
      <OrgDocsTable />
    </LayoutDefault>
  );
}
